export default __webpack_public_path__ + "static/media/web.78dff311.png";